import { createContext, useContext } from "react";

export const ScoutCardContext = createContext({
  surface: null,
  openSupport: null,
  openExpertMeeting: null,
  shareCustomerYear: null,
  acceptSupplierShare: null
});

export const useScoutCardContext = () => useContext(ScoutCardContext);
